import Spinner from './Spinner';
import { useEffect, useState } from 'react';

type LongLoaderProps = {
  isLoading: boolean;
  children?: React.ReactNode;
  timeout?: number;
}

const LongLoader = ({ isLoading, children, timeout = 1000 }: LongLoaderProps) => {

  const [isLoadingLong, setIsLoadingLong] = useState(false);

  useEffect(
    () => {
      let timeoutId: NodeJS.Timeout | undefined = undefined;
      if (isLoading) {
        timeoutId = setTimeout(() => {
          setIsLoadingLong(true);
        }, timeout);
      }
      if (!isLoading) {
        clearTimeout(timeoutId);
        setIsLoadingLong(false);
        timeoutId = undefined;
      }

      return () => {
        clearTimeout(timeoutId);
        timeoutId = undefined;
      }
    },
    [isLoading, timeout]
  )

  return (
    <div className="absolute bg-white border flex gap-3 border-base-back-3 drop-shadow-md top-7 left-1/4 w-2/4 z-10 rounded-md overflow-hidden text-body-1-xl font-bold" hidden={!isLoadingLong}>
      <div className="bg-orange-500 p-2 text-white flex items-center"><Spinner show className="size-6" /></div>
      <div className="self-center p-2">{children}</div>
    </div>
  )
};

export default LongLoader;
